import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
import { useDropdownMenu } from '@restart/ui';
import useMergedRefs from '@restart/hooks/useMergedRefs';
export const DropdownMenu = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className, rootCloseEvent, flip = true, show: showProps, renderOnMount, componentClass: Component = 'div', popperConfig, usePopper = true, ...rest } = props;
    const prefix = 'dropdown-menu';
    const [menuProps, { hasShown, popper, show, toggle }] = useDropdownMenu({
        flip,
        rootCloseEvent,
        show: showProps,
        usePopper: usePopper,
        offset: [
            0,
            2
        ],
        popperConfig
    });
    const extraProps = {};
    extraProps.ref = useMergedRefs(ref, menuProps.ref);
    if (!hasShown && !renderOnMount) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        extraProps.show = show;
        extraProps.close = ()=>toggle?.(false);
    }
    let style = props.style;
    if (popper?.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        extraProps['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ _jsx(Component, {
        ...rest,
        ...menuProps,
        ...extraProps,
        style: style,
        className: classNames(className, prefix, show && 'show')
    });
});
DropdownMenu.displayName = 'DropdownMenu';
